/* eslint-disable */
import React, {useState} from 'react';
import Tab from '../../component/Inc/Tab';
import 'contents/assets/scss/page/teacher.scss';

function Map() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '1순위', value: 1},
    {title: '2순위', value: 2}
  ];
  return (
    <main className="com_container p_teacher_map">
			{/* 20250218 퍼블 추가 & 수정 */}
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_3 active">교사 배정지도</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">수업 등록</button>
            <button className="com_btn orange s btn_plus">교사 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top sec_top">
              <div className="board_select">
                <select className="select">
                  <option>지역선택</option>
                </select>
                <select className="select">
                  <option>지역선택</option>
                </select>
                <select className="select">
                  <option>지역선택</option>
                </select>
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              </div>

              <div className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top first">
              <div className="com_radio_wrap ">
                <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                <label htmlFor="rdo01">전체</label>
                <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                <label htmlFor="rdo02">대면</label>
                <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                <label htmlFor="rdo02">화상</label>
                <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                <label htmlFor="rdo02">수시</label>
              </div>
              <div className="com_radio_wrap">
                <input type="checkbox" id="chk01" className="com_chk" />
                <label htmlFor="chk01">원거리 가능</label>
                <input type="checkbox" id="chk02" className="com_chk" />
                <label htmlFor="chk02">신규강사</label>
                <input type="checkbox" id="chk03" className="com_chk" />
                <label htmlFor="chk03">배정대기</label>
              </div>

            </div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="7%" />
                  <col width="13%" span={6}/>
                  <col width="auto" />
                </colgroup>
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>교사명</th>
                    <th>과목</th>
                    <th>1순위</th>
                    <th>2순위</th>
                    <th>희망타임</th>
                    <th>진행타임</th>
                    <th>비고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>
                      <button className="btn_link">홍길동</button>
                    </td>
                    <td>국어</td>
                    <td>국어</td>
                    <td>경기도</td>
                    <td>6</td>
                    <td className="td_point">6</td>
                    <td className="td_point">원거리 가능</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>
                      <button className="btn_link">홍길동</button>
                    </td>
                    <td>국어</td>
                    <td>국어</td>
                    <td className="td_red">배정대기</td>
                    <td>6</td>
                    <td className="td_red">6</td>
                    <td className="td_red">배정대기</td>
                  </tr>
                  {[...Array(6)].map((i, idx) => (
                    <tr key={idx}>
                      <td>{idx + 3}</td>
                      <td>
                        <button className="btn_link">홍길동</button>
                      </td>
                      <td>국어</td>
                      <td>국어</td>
                      <td>경기도</td>
                      <td>6</td>
                      <td className="td_point">6</td>
                      <td className="td_point">신규강사</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Map;
